import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { css, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const ManagePageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 11px;
`

export const HeadContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 7px;
`

export const ItemsTotalTypography = styled(Typography)`
  padding-left: 7px;
  border-left: 1px solid ${colors.lightGrey};
`

export const ManagePagePaper = styled('div')`
  margin: 0 ${componentSizes.smDistance} 0 0;
`

export const ManagePagePaperInner = styled('div')`
  background-color: ${colors.white};
  padding: ${componentSizes.smDistance} ${componentSizes.smDistance} 0;
  border: 1px solid #dadada;
  position: relative;
  overflow: hidden;
`

export const ManageTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const TableNavigationBox = styled(Box)`
  margin-top: 4px;
  margin-bottom: ${componentSizes.smDistance};

  &:first-child {
    margin: ${componentSizes.smDistance} 0 0;
  }
  &:last-child {
    margin: 0 0 ${componentSizes.smDistance};
  }
`

export const TopTabsNavigationContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: ${componentSizes.smDistance};
  margin-bottom: ${componentSizes.smDistance};
  max-height: 48px;
`

export const TabsWrapper = styled('div')`
  max-width: 60%;
  margin-right: 40px;
`

export const TableWrapper = styled(Box)`
  position: relative;
  width: 100%;
  margin-bottom: 5px;
`

export const StyledTableRow = styled(TableRow)<{ $isActive: boolean; $isUpdated: boolean; $isHighlighted: boolean }>`
  border-left: 1px solid ${colors.white};
  border-right: 1px solid ${colors.white};
  opacity: ${({ $isActive }: { $isActive: boolean }) => ($isActive ? 1 : 0.4)};
  ${({ $isHighlighted }: { $isHighlighted: boolean }) =>
    $isHighlighted
      ? css`
          height: 70px;
          border: 1px solid ${colors.primary};
          position: relative;
        `
      : ''}
`

export const StyledTableCell = styled(TableCell)`
  background-color: ${colors.white};
  background-clip: padding-box;
  border: none;
  padding: 8px 13px;
  border-top: 1px solid ${colors.lightGrey};
  ${(props: {
    $nowrap?: boolean
    $isNameCell?: boolean
    $cellWidth?: number
    $fixedWidth?: boolean
    $isDisabled: boolean
    $header: boolean
  }) => {
    let extraRules = ''
    if (props.$nowrap) {
      extraRules += 'white-space: nowrap; '
    }
    if (props.$cellWidth) {
      extraRules += `min-width: ${props.$cellWidth}px; `
    }
    if (props.$fixedWidth) {
      extraRules += `width: ${props.$cellWidth}px; `
      extraRules += `max-width: ${props.$cellWidth}px; `
    }
    if (props.$isDisabled) {
      extraRules += ' pointer-events: none;'
    }
    if (props.$header) {
      extraRules += ' border: none;'
    }

    return extraRules
  }};
`

export const TableCellInner = styled('div')`
  display: flex;
  align-items: center;
  color: ${colors.bodyText};
  background: ${colors.white};
`
